import React from 'react';
import uuid from 'uuid/v4';
import { View } from '@applane/react-core-components';
import FloatingActions from '../action/FloatingActions';
import {
  screenHeaderToolBarTheme,
  screenHeaderToolBarMobileTheme,
  screenFooterToolBarTheme,
} from '../../theme/toolBarTheme';
import FilterBar from '../filter/FilterBar';
import { isMobile } from '../UtilityFunctions';
import ToolBar from '../toolBar/ToolBar';

export class ScreenComponent extends React.Component {
  state = {};

  constructor(props) {
    super(props);
    const { uid, fetchUriEvent } = props;
    this.fetchUriEvent = fetchUriEvent || `${uid || uuid()}_fetchUri`;
  }

  setScreenData = ({ state } = {}) => {
    this.setState({
      data: state?.data,
      fetchMoreProps: state?.fetchMoreProps,
      aggregates: state?.aggregates,
    });
  };

  componentDidMount() {
    const { eventDispatcher } = this.props;
    eventDispatcher?.listen
      && eventDispatcher.listen(
        `${this.fetchUriEvent}_loadData`,
        this.setScreenData,
      );
  }

  componentWillUnmount() {
    const { eventDispatcher } = this.props;
    eventDispatcher?.unlisten
      && eventDispatcher.unlisten(
        `${this.fetchUriEvent}_loadData`,
        this.setScreenData,
      );
  }

  render() {
    let {
      screen: Component,
      floatingActions,
      header,
      footer,
      navigation,
      eventDispatcher,
      screenState,
      setScreenState,
      state,
      setState,
      setTabsState,
      ...rest
    } = this.props;

    const navigationScreenState = (navigation
        && navigation.getScreenState
        && navigation.getScreenState())
      || {};
    const componentProps = {
      fetchUriEvent: this.fetchUriEvent,
      navigation,
      eventDispatcher,
      screenState,
      setScreenState,
      state,
      setState,
      setTabsState,
    };
    const { filterAction } = navigationScreenState;
    let absoulteTopFilterBar = void 0;
    if (filterAction) {
      if (filterAction.position === 'absolute') {
        absoulteTopFilterBar = (
          <FilterBar
            absolutePosition="top"
            {...componentProps}
            {...filterAction}
          />
        );
      } else {
        header = { ...header };
        header.actions = header.actions ? [...header.actions] : [];
        header.actions.unshift(
          <FilterBar {...componentProps} {...filterAction} />,
        );
      }
    }

    return (
      <View style={{ flex: 1, overflow: 'hidden' }}>
        {absoulteTopFilterBar}
        {header && (
          <ToolBar
            {...(isMobile
              ? screenHeaderToolBarMobileTheme
              : screenHeaderToolBarTheme)}
            {...componentProps}
            {...header}
            {...this.state}
          />
        )}
        <Component
          {...componentProps}
          {...rest}
          dataParams={screenState && screenState.dataParams}
        />
        {footer && (
          <ToolBar
            {...screenFooterToolBarTheme}
            {...componentProps}
            {...footer}
            {...this.state}
          />
        )}
        <FloatingActions
          floatingActions={floatingActions}
          {...componentProps}
          {...rest}
        />
      </View>
    );
  }
}

export default ScreenComponent;
